type Cover = {
  url: string;
};

export const availableCovers: Cover[] = [
  {
    url: "https://firebasestorage.googleapis.com/v0/b/planira-1337.appspot.com/o/covers%2Flibrary%2Fcover_0000_Lager%2018.jpg?alt=media&token=a3026544-d4f0-4a3a-a0ba-09f2937e6fc0",
  },

  {
    url: "https://firebasestorage.googleapis.com/v0/b/planira-1337.appspot.com/o/covers%2Flibrary%2Fcover_0001_Lager%2017.jpg?alt=media&token=0c9c43e1-53cc-4723-9ef7-3188cfbb37ef",
  },

  {
    url: "https://firebasestorage.googleapis.com/v0/b/planira-1337.appspot.com/o/covers%2Flibrary%2Fcover_0002_Lager%2016.jpg?alt=media&token=df1ca356-24ed-4ff4-8e6c-e23cc1de7770",
  },

  {
    url: "https://firebasestorage.googleapis.com/v0/b/planira-1337.appspot.com/o/covers%2Flibrary%2Fcover_0003_Lager%2015.jpg?alt=media&token=cca7ff7f-5595-44e8-8d7d-9885d3edc238",
  },

  {
    url: "https://firebasestorage.googleapis.com/v0/b/planira-1337.appspot.com/o/covers%2Flibrary%2Fcover_0004_Lager%2014.jpg?alt=media&token=c20664fa-58e4-43e5-9e7c-3e3163f465cd",
  },

  {
    url: "https://firebasestorage.googleapis.com/v0/b/planira-1337.appspot.com/o/covers%2Flibrary%2Fcover_0005_Lager%2013.jpg?alt=media&token=2b9a73df-785b-4278-9dda-b5171f8c87a1",
  },

  {
    url: "https://firebasestorage.googleapis.com/v0/b/planira-1337.appspot.com/o/covers%2Flibrary%2Fcover_0006_Lager%2012.jpg?alt=media&token=69d3f0be-8a83-4093-a554-87ec8bd53def",
  },

  {
    url: "https://firebasestorage.googleapis.com/v0/b/planira-1337.appspot.com/o/covers%2Flibrary%2Fcover_0007_Lager%2011.jpg?alt=media&token=a9431eac-b408-4e69-b5c3-59435ec8a36a",
  },

  {
    url: "https://firebasestorage.googleapis.com/v0/b/planira-1337.appspot.com/o/covers%2Flibrary%2Fcover_0008_Lager%2010.jpg?alt=media&token=0be04ac5-f5f0-4866-9af4-d76cf59cdf9f",
  },

  {
    url: "https://firebasestorage.googleapis.com/v0/b/planira-1337.appspot.com/o/covers%2Flibrary%2Fcover_0009_Lager%209.jpg?alt=media&token=f0a0a2f7-f269-40a6-aa5a-b6efce3078df",
  },

  {
    url: "https://firebasestorage.googleapis.com/v0/b/planira-1337.appspot.com/o/covers%2Flibrary%2Fcover_0010_Lager%208.jpg?alt=media&token=51f558df-c1d9-40c8-9002-1631ccd5e81b",
  },

  {
    url: "https://firebasestorage.googleapis.com/v0/b/planira-1337.appspot.com/o/covers%2Flibrary%2Fcover_0011_Lager%207.jpg?alt=media&token=5b38017f-9241-4314-af9d-92568cb04651",
  },
  {
    url: "https://firebasestorage.googleapis.com/v0/b/planira-1337.appspot.com/o/covers%2Flibrary%2Fcover_0012_Lager%206.jpg?alt=media&token=61b48a5b-9b4f-4c39-9bba-78804887d9df",
  },

  {
    url: "https://firebasestorage.googleapis.com/v0/b/planira-1337.appspot.com/o/covers%2Flibrary%2Fcover_0013_Lager%205.jpg?alt=media&token=e1c5b334-1350-4f2f-add9-153551888e87",
  },

  {
    url: "https://firebasestorage.googleapis.com/v0/b/planira-1337.appspot.com/o/covers%2Flibrary%2Fcover_0014_Lager%204.jpg?alt=media&token=5cb4fd16-71ba-4eaa-899e-0e6e7c6a9ff9",
  },

  {
    url: "https://firebasestorage.googleapis.com/v0/b/planira-1337.appspot.com/o/covers%2Flibrary%2Fcover_0015_Lager%203.jpg?alt=media&token=497e59d4-7a83-439c-add1-a29dfe294930",
  },

  {
    url: "https://firebasestorage.googleapis.com/v0/b/planira-1337.appspot.com/o/covers%2Flibrary%2Fcover_0016_Lager%202.jpg?alt=media&token=fb672eb6-2b32-4505-b16e-8fa138718bc0",
  },

  {
    url: "https://firebasestorage.googleapis.com/v0/b/planira-1337.appspot.com/o/covers%2Flibrary%2Fcover_0017_Lager%201.jpg?alt=media&token=e733e39c-5a8b-4941-9e50-57b11e177d65",
  },
];
